import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage/HomePage'
import FilesPage from './pages/FilesPage'
import SearchPage from './pages/SearchPage'
import CollectionPage from './pages/CollectionPage/CollectionPage'
import RecentlyAddedPage from './pages/RecentlyAddedPage'
import globalStyles from './styles/globals.module.css'

function App() {
  return (
    <div className={globalStyles.app}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/recently-added" element={<RecentlyAddedPage />} />
        <Route path="/files" element={<FilesPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/collection/:collectionId" element={<CollectionPage />} />
      </Routes>
    </div>
  )
}

export default App